<button class="new-theme-typography early-access-select-button" (click)="FeatureToggle.toggle()">
    <div class="early-access-selection" [class.last]="last">
        <div class="flex flex-row justify-between items-center">
            <mat-checkbox #FeatureToggle [checked]="feature.enabled" (change)="handleFeatureChange($event)" (click)="$event.stopPropagation();">
                <span class="early-access-checkbox-label">{{ feature.description }}</span>
            </mat-checkbox>
            <app-early-access-label [featureType]="feature.type"></app-early-access-label>
        </div>
        <div class="early-access-feature-subtexts">
            @for (subtext of feature.subtexts; track subtext) {
                <div class="early-access-subtext-wrapper">
                    <div class="early-access-subtext">
                        {{ subtext }}
                    </div>
                </div>
            }
        </div>
    </div>
</button>
